import React, { createContext, useState } from "react"
import { useSearchParams } from "react-router"
import useRawState from "../hooks/useRawState"

const VenueContext = createContext()
export default VenueContext

export function QueryBasedVenueProvider({ children }) {
    const [searchParams] = useSearchParams()
    const venueId = searchParams.get('venue')

    return <VenueProvider venueId={venueId} children={children} />
}

function VenueProvider({ venueId, ...props }) {
    const venueResult = useRawState(`/api/current/venues/${venueId}`)

    return <VenueContext.Provider value={venueResult} {...props} />
}